module.exports = __webpack_public_path__ + "static/scale-model-of-holiday-light-show-on-lyndale-in-minneapolis-minnesota-d97db0566959507c9ca50e75afbea358.png";